import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import { DateTime } from 'scaleflow/utils/date-time';
import type InitiativeModel from './initiative';
import type InvestmentScenarioModel from './investment-scenario';

export default class RoadmapModel extends Model {
  declare [Type]: 'roadmap';
  @attr('string', { defaultValue: '' }) declare title: string;
  // @ts-expect-error: attr's types only allow functions that return objects
  @attr('string', { defaultValue: () => new Date().toISOString() })
  declare start_date: string;
  // @ts-expect-error: attr's types only allow functions that return objects
  @attr('string', { defaultValue: () => new Date().toISOString() })
  declare end_date: string;
  @belongsTo('investment-scenario', { async: true, inverse: 'roadmaps' })
  declare 'investment-scenario': AsyncBelongsTo<InvestmentScenarioModel>;
  @hasMany('initiative', { async: true, inverse: 'roadmaps' })
  declare initiatives: AsyncHasMany<InitiativeModel>;

  get weeks() {
    return DateTime.from(this.end_date).diff(
      DateTime.from(this.start_date),
      'weeks',
      true,
    );
  }

  get initiativeIds() {
    return this.initiatives.content?.map((item) => item.id);
  }

  get expected_investment() {
    return this.initiatives?.content?.reduce(
      (acc, item) => Number(acc) + Number(item.bon_investment ?? 0),
      0,
    );
  }

  get expected_return() {
    return this.initiatives?.content?.reduce(
      (acc, item) => Number(acc) + Number(item.bon_returns ?? 0),
      0,
    );
  }

  get expected_value() {
    return this.initiatives?.content?.reduce(
      (acc, item) => Number(acc) + Number(item.bon_value ?? 0),
      0,
    );
  }

  get investmentScenario() {
    return this['investment-scenario']?.content;
  }
}
